import React, { useState } from "react";
import { BsSuitHeartFill } from "react-icons/bs";
import { FaShoppingCart } from "react-icons/fa";
import Image from "../../designLayouts/Image";
import Badge from "./Badge";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../../redux/orebiSlice";
import toast from 'react-hot-toast';

const Product = (props) => {
  const dispatch = useDispatch();
  const [addedToCart, setAddedToCart] = useState(false);
  const _id = props.productName;
  const idString = (_id) => {
    return String(_id).toLowerCase().split(" ").join("");
  };
  const rootId = idString(_id);

  const navigate = useNavigate();
  const productItem = props;
  const handleProductDetails = () => {
    navigate(`/product/${rootId}`, {
      state: {
        item: productItem
      }
    });
  };

  const handleAddToCart = () => {
    dispatch(
      addToCart({
        _id: props._id,
        name: props.productName,
        quantity: 1,
        image: props.img,
        badge: props.badge,
        price: props.price,
        colors: props.color
      })
    );
    setAddedToCart(true);
    toast.success(`${props.productName} added to cart!`, {
      position: 'bottom-right',
      style: {
        background: '#333',
        color: '#fff',
      },
      iconTheme: {
        primary: '#4ade80',
        secondary: '#fff',
      },
    });
    setTimeout(() => setAddedToCart(false), 1500);
  };
  console.log("props.price:", props.price);
  console.log("props.displayPrice:", props.displayPrice);

  return (
    <div className="w-full relative group">
      <div className="max-w-80 max-h-80 relative overflow-hidden rounded-xl shadow-md transition-all duration-300 ease-in-out hover:shadow-2xl transform hover:-translate-y-1">
        <div onClick={handleProductDetails} className="cursor-pointer relative">
          <Image className="w-full h-[280px] object-cover transform transition-transform duration-300 group-hover:scale-105" imgSrc={props.img} />
        </div>
        <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black/70 to-transparent">
          <h2 className="text-white font-semibold text-lg mb-1 truncate">
            {props.productName}
          </h2>
          <div className="flex justify-between items-center">
            <p className="text-white font-bold">
              EGP {props.recipe == 1 ? props.displayPrice : props.price}
            </p>
            {props.recipe == 1 ? null : (
              <span className="text-sm text-white">
                / {props.unitValue} {props.unitName}
              </span>
            )}
            <div className="flex gap-2">

              <button className="bg-white/90 hover:bg-white p-2 rounded-full transition-colors duration-200">
                <BsSuitHeartFill className="text-gray-800 text-lg" />
              </button>
            </div>
          </div>
        </div>
        <div className="absolute top-4 right-3">
          <button
            onClick={handleAddToCart}
            disabled={addedToCart}
            className={`relative ${addedToCart
              ? 'bg-green-500 hover:bg-green-600'
              : 'bg-white/90 hover:bg-white'
              } p-2 rounded-full transition-all duration-300 overflow-hidden`}
          >
            {addedToCart ? (
              <svg
                className="w-5 h-5 text-white animate-bounce"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            ) : (
              <FaShoppingCart className={`text-lg ${addedToCart ? 'text-white' : 'text-gray-800'}`} />
            )}
          </button>
        </div>

        {props.badge && (
          <div className="absolute top-2 left-2">
            <Badge text="New" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Product;
